<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M3.025 14.401c-.714.6-.29 1.766.644 1.766H6v10.166C6 27.253 6.747 28 7.667 28H14V18h4v10h6.334c.92 0 1.666-.746 1.666-1.667V16.167h2.332c.933 0 1.357-1.165.643-1.766L17.073 4.391a1.667 1.667 0 00-2.146 0L3.026 14.401zM20 26h4V12.83l-8-6.728-8 6.729V26h4v-8.333c0-.92.746-1.667 1.667-1.667h4.667c.92 0 1.666.746 1.666 1.667V26z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'placesHomeOutline'
}
</script>
